import { toast } from 'vue-sonner'

import bus from '@/mixins/bus'

/**
 * Triggers a snackbar notification using the `$notify` method
 * @mixin
 */
export default {
  name: 'Notify',
  mixins: [bus],
  methods: {
    $notify(message, mode = 'info', options = {}) {
      const onDismiss = options.onClose
      switch (mode) {
        case 'success':
          toast.success(message, { onDismiss })
          break
        case 'error':
          toast.error(message, { onDismiss })
          break
        case 'warning':
          toast.warning(message, { onDismiss })
          break
        default:
          toast.info(message, { onDismiss })
      }
    },
  },
}
